"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var GuidedImageStep = function GuidedImageStep(_ref) {
  var children = _ref.children,
      offsetTop = _ref.offsetTop,
      offsetLeft = _ref.offsetLeft,
      content = _ref.content,
      className = _ref.className,
      otherProps = _ref.otherProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showStep = _useState2[0],
      setShowStep = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(StyledStep, _extends({
    offsetTop: offsetTop,
    offsetLeft: offsetLeft,
    className: className
  }, otherProps, {
    onMouseEnter: function onMouseEnter() {
      setShowStep(!showStep);
    },
    onMouseLeave: function onMouseLeave() {
      setShowStep(!showStep);
    }
  }), /*#__PURE__*/_react.default.createElement(StyledStepToolTip, {
    active: showStep
  }, content), children);
};

var StyledStep = _styledComponents.default.div.withConfig({
  displayName: "StyledStep"
})(["position:absolute;top:", ";left:", ";font-family:", ";width:2rem;height:2rem;background-color:", ";border-radius:9999px;font-weight:500;font-size:1.2rem;line-height:1.5rem;color:white;display:flex;justify-content:center;align-items:center;cursor:pointer;"], function (_ref2) {
  var offsetTop = _ref2.offsetTop;
  return offsetTop;
}, function (_ref3) {
  var offsetLeft = _ref3.offsetLeft;
  return offsetLeft;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.font;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

var StyledStepToolTip = _styledComponents.default.div.withConfig({
  displayName: "StyledStepToolTip"
})(["position:absolute;display:", ";width:300px;background-color:#222;bottom:2.8rem;color:white;padding:0.8rem;border-radius:5px;font-family:", ";font-size:1.2rem;line-height:1.6rem;&::after,&::before{top:100%;left:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}&::after{border-color:transparent;border-top-color:#222;border-width:6px;margin-left:-6px;}"], function (_ref6) {
  var active = _ref6.active;
  return active ? 'block' : 'none';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
});

GuidedImageStep.defaultProps = {
  children: '0',
  offsetTop: '0px',
  offsetLeft: '0px',
  content: 'Enter some text to be displayed here.'
};
GuidedImageStep.propTypes = {
  /** Content of the step */
  children: _propTypes.node.isRequired,

  /** Defines how far the dot is from the top of the image. (Px / %) */
  offsetTop: _propTypes.string.isRequired,

  /** Defines how far the dot is from the left of the image. (Px / %) */
  offsetLeft: _propTypes.string.isRequired,

  /** Content of the tooltip */
  content: _propTypes.string.isRequired,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = GuidedImageStep;
exports.default = _default;